import Immutable from "seamless-immutable";

export function addItem(items, item) {
  if (!item) return items;

  items = Immutable.asMutable(items);
  items.push(item);
  items.sort((a, b) => a.datePosted - b.datePosted);

  return items;
}

export function replaceInItems(items, newItem) {
  if (!newItem) return items;

  let i = items.findIndex(item => item.id === newItem.id);
  if (i !== -1) {
    items = Immutable.set(items, i, newItem);
    items = Immutable.asMutable(items);
    items.sort((a, b) => a.datePosted - b.datePosted);
  }

  return items;
}

export function addItems(items, newItems) {
  if (!newItems) return items;

  items = [...items];

  if (Array.isArray(newItems)) {
    items.push(...newItems);
  } else {
    items.push(newItems);
  }

  items.sort((a, b) => new Date(a.datePosted) - new Date(b.datePosted));

  return items;
}

export function replaceOrAddItems(items, newItems) {
  if (!newItems) return items;

  const newItemsArray = Array.isArray(newItems) ? newItems : [newItems];

  let updatedItems = [...items];

  newItemsArray.forEach(newItem => {
    const index = updatedItems.findIndex(item => item.id === newItem.id);
    if (index !== -1) {
      updatedItems[index] = newItem;
    } else {
      updatedItems.push(newItem);
    }
  });

  updatedItems.sort((a, b) => new Date(a.datePosted) - new Date(b.datePosted));

  return updatedItems;
}
